<template>
  <div v-if="show" class="alert-block">
    <div v-if="status === 'success'" class="alert alert-success alert-dismissible">
      <button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button>
      <h4>{{ $t(text) }}</h4>
    </div>

    <div v-if="status === 'error'" class="alert alert-danger alert-dismissible">
      <button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button>
      <h4>{{ $t(text) }}</h4>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Alert',
  data () {
    return {
      status: String,
      text: String,
      show: Boolean
    };
  },
  created () {
    this.show = false;
    this.$root.$on('alert', this.megaEventHandler);
  },
  methods: {
    megaEventHandler (status, text) {
      var self = this;

      this.status = status;
      this.text = text;

      this.show = true;

      setTimeout(function () {
        self.show = false;
      }, 5000);
    }
  }
};
</script>

<style scoped>
  .alert-block {
    position: fixed;
    right: 0;
    top: 60px;
    width: 300px;
    z-index: 1000000;
  }
</style>
